import { render } from "./table-history-success-booking.vue?vue&type=template&id=7e894ea0&scoped=true&ts=true"
import script from "./table-history-success-booking.vue?vue&type=script&lang=ts"
export * from "./table-history-success-booking.vue?vue&type=script&lang=ts"

import "./table-history-success-booking.vue?vue&type=style&index=0&id=7e894ea0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e894ea0"]])

export default __exports__